import styled from "styled-components";
import { colors, fonts } from "../../consts";

export const TooltipWrapper = styled.div`
  position: fixed !important;
  visibility: hidden;
  ${(props) =>
    props.position &&
    `transform: translate(${props.position[1]}px, ${props.position[0]}px) !important;`}

  padding: 4px 6px;
  background-color: ${colors.RAISIN_100};
  border-radius: 4px;

  font-family: ${fonts.PLUS_JAKARTA_SANS};
  color: ${colors.WHITE};
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
  z-index: 1000;

  &[data-show="true"] {
    visibility: visible;
  }
`;
